import { render, staticRenderFns } from "./MservicetechnicianIndex.vue?vue&type=template&id=1a9673b9"
import script from "./MservicetechnicianIndex.vue?vue&type=script&lang=js"
export * from "./MservicetechnicianIndex.vue?vue&type=script&lang=js"
import style0 from "./MservicetechnicianIndex.vue?vue&type=style&index=0&id=1a9673b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports